


    <div class="modal-header">
        <span class="modal-header-title">Загрузка нового файла</span>
        <!-- <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss(false)">
            <span aria-hidden="true"><i class="bi bi-x-lg" style="font-size: 16px;"></i></span>
        </button> -->
        <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss(false)">
            <svg-icon  src="/assets/images/icons/close.svg" [stretch]="true"
            [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
        </button>
    </div>

    <div class="modal-body">

        <div class="row">

            <div class="col-8 date-field">
                    
                <form class="form" [formGroup]="dateForm" autocomplete="off">

                    <!-- sell_​​by -->
                    <label class="label" for="date">Срок действия</label>
                    <div class="form-group">
                        <app-date-picker-custom-view-control (changeValue)="eventFnDPVC('sell_by', $event)" [valueDateTo]="valueDate"></app-date-picker-custom-view-control>
                        <div *ngIf="errorMessages">
                            <div *ngFor="let item of errorMessages.sell_by">
                                <div class="text-error" *ngIf="validation('sell_by', item.type)">
                                    {{ item.message | translate: item.options }}
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>

            <div class="col-4">
                <!-- UPLOAD_FILE -->
                <div class="file-upload">
                    <label class="label" for="date" style="margin-bottom: 12px;">Загрузить файлы</label>
                    <ff-button-upload-files 
                    label="Выбрать" 
                    [component]="component" 
                    [multiple]="btnUploadFilesMultiple" 
                    [date]="this.dateForm.get('sell_by').value != null ? this.dateForm.get('sell_by').value : null" 
                    (uploadedFiles)="uploadFiles($event)">
                    </ff-button-upload-files>
                </div>
            </div>

        </div>

    </div>

    <div class="modal-footer btn-box">
        <button type="button" class="btn btn-light btn-sm btn-custom-actions"   (click)="activeModal.dismiss(false)">{{ 'CLOSE' | translate}}</button>
    </div>

    <!-- content -->
    <!-- <div class="card-content">
        <div class="row content">

          
        </div>

        <div class="row">
           
        </div>

    </div> -->

